export default __webpack_public_path__ + "static/media/IMG_5531.a929f23e.jpg";